module.exports = __webpack_public_path__ + "img/symbol_0.d7be7724.png";